<template>
  <div>
    <strong>{{ opts.nomeCliente }}</strong>
    <button @click="closethis()" class="ui right floated icon button">
      <i class="close icon"></i>
    </button>
    <div class="ui basic segment animated fadeIn">
      <strong class="headline">Banco: {{ opts.banco }}</strong>
      <div class="ui form">
        <div class="titles-info">
          <div class="info-field">
            <label>Cedente</label>
            <input
              :value="opts.CpfCedente"
              placeholder
              v-mask="mask"
              required/>
            <button @click="doCopy(opts.CpfCedente)" class="ui icon button">
              <i class="copy icon"></i>
            </button>
          </div>
          <div class="info-field">
            <label>CNPJ</label>
            <input
              :value="opts.CpfSacado"
              v-mask="mask"
              required/>
            <button @click="doCopy(opts.CpfSacado)" class="ui icon button">
              <i class="copy icon"></i>
            </button>
          </div>
          <div class="info-field">
            <label>Nosso Numero</label>
            <input :value="opts.NossoNum" required/>
            <button @click="doCopy(opts.NossoNum)" class="ui icon button">
              <i class="copy icon"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <button @click="abrirBanco()">Acessar Banco</button>
    <div class="container">
      <div v-if="!bancoCuzao">
        <iframe
          title="Banco"
          id="mainFrame"
          v-if="iframe.loaded"
          class="responsive-iframe"
          :src="iframe.src"
          v-on:load="load()"
          allowfullscreen
        ></iframe>
      </div>
      <div v-if="bancoCuzao">
        <div>
          <p class="display-1 text--primary">2-Via de Boleto</p>
          <div class="text--primary">
            Você será redirecionado para o sistem do banco ao clicar em "Copiar Chave"
            {{ opts.banco.trim() }}
            <br />
            {{
              opts.banco === "santander" ? opts.NossoNum.trim() :
              `${opts.agencia.trim()}${opts.conta.trim()}${opts.NossoNum.trim()}`
            }}
          </div>
        </div>
        <button
          v-if="havedoCopy"
          @click="abrirBancoCuzao()"
          text
          color="deep-purple accent-4"
        >
          <i class="check icon"></i>
          Acessar Banco
        </button>
        <button @click="doItauCopy(opts)">Copiar Chave</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import closeableHeaderLabel from "./closeable-header-label.vue";
export default {
  components: { closeableHeaderLabel },
  name: "BoletoBanco",
  props: ["opts", "dialog"],
  directives: {
    mask,
  },
  watch: {
    dialog: function (val) {
      if (val) {
        this.defMainColor();
        this.setupThis();
      }
    },
  },
  mounted() {
    this.defMainColor();
    this.setupThis();
  },
  data: () => ({
    mask: "##.###.###/####-##",
    bancoCuzao: false,
    havedoCopy: false,
    urlBancoCuzao: "",
    frame: {},
    iframe: {
      src: "",
      loaded: false,
    },
    mainColor: "primary",
    classBtn: "white--text",
  }),
  methods: {
    doItauCopy: function (opts) {
      let copyText = `${opts.agencia.trim()}${opts.conta.trim()}${opts.NossoNum.trim()}`;
      if (this.opts.banco === "santander") {
        copyText = `${opts.NossoNum.trim()}`;
      }

      this.$copyText(copyText);
      this.havedoCopy = true;
    },
    doCopy: function (texto) {
      let textCopy = texto
        .replace(".", "")
        .replace(".", "")
        .replace("/", "")
        .replace("-", "");
      this.$copyText(textCopy);
      return textCopy;
    },
    defMainColor: async function () {
      if (this.opts.banco === "bradesco") {
        this.mainColor = "#cc092f";
        this.classBtn = "white--text";
      } else if (this.opts.banco === "safra") {
        this.mainColor = "#151e45";
        this.classBtn = "white--text";
      } else if (this.opts.banco === "itau") {
        this.mainColor = "#ec7000";
        this.classBtn = "white--text";
      } else if (this.opts.banco === "brasil") {
        this.mainColor = "#f8d117";
        this.classBtn = "white--text";
      } else if (this.opts.banco === "santander") {
        this.mainColor = "#dc143c";
        this.classBtn = "white--text";
      }
    },
    setupThis() {
      if (this.opts.banco === "bradesco") {
        this.iframe.src =
          "https://www.ib12.bradesco.com.br/ibpfsegundaviaboleto/segundaViaBoletoPesquisarCPFCNPJ.do";
        this.iframe.loaded = true;
      } else if (this.opts.banco === "safra") {
        this.iframe.src = `https://wwws.safraempresas.com.br/pjseguro/SacadosConsultaBoletoCobr_NCS.asp?origem=C&stpf=1&Sacado=${this.doCopy(
          this.opts.CpfSacado
        )}&NossoNum=${this.doCopy(this.opts.NossoNum)}`;
        this.iframe.loaded = true;
      } else if (this.opts.banco === "itau") {
        if (this.opts.vencido) {
          this.urlBancoCuzao =
            "https://www.itau.com.br/servicos/boletos/atualizar/";
        } else {
          this.urlBancoCuzao =
            "https://www.itau.com.br/servicos/boletos/segunda-via/";
        }
        this.iframe.src = "";
        this.iframe.loaded = false;
        this.bancoCuzao = true;
      } else if (this.opts.banco === "brasil") {
        this.iframe.src =
          "https://www63.bb.com.br/portalbb/boleto/boletos/hc21e,802,3322,10343.bbx";
        this.iframe.loaded = true;
      } else if (this.opts.banco === "santander") {
        this.urlBancoCuzao = "https://www.santander.com.br/2-via-boleto";
        this.iframe.src = "";
        this.iframe.loaded = false;
        this.bancoCuzao = true;
      }
    },
    abrirBanco() {
      window.open(this.iframe.src, "_blank", "width=900,height=auto");
    },
    abrirBancoCuzao() {
      window.open(this.urlBancoCuzao, "_blank", "width=900,height=auto");
    },
    closethis() {
      this.iframe.src = "";
      this.iframe.loaded = false;
      this.$emit("close", "");
    },
    load() {
      const ifrm = document.getElementById("mainFrame");
      console.log(ifrm);
    },
  },
};
</script>

<style>
.responsive-iframe {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 400px;
  border: 0;
}
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  /* padding-top: 56.25%; 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.titles-info {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.titles-info div.info-field {
  display: flex;
  align-items: center;
  gap: 10px;
  row-gap: 10px;
  width: 100%;
  min-width: 250px;
  max-width: 350px;
}

.info-field {
  margin-bottom: 5px;
}

.titles-info div.info-field :nth-child(1) {
  width: 30%;
}

.titles-info div.info-field :nth-child(2) {
  width: 68%;
}

.titles-info div.info-field :nth-child(3) {
  width: 12%;
}

.titles-info div.info-field :nth-child(3) :first-child {
  margin-left: -50% !important;
}
</style>